module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Semibold.6f86fd2.woff";